// Components/ui
import { SubsectionBodyContainer } from '../../../../layout';
import { Whatsapp } from './components';
// Types
import { NewAddress } from '../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  whatsapps: Array<NewAddress | IContactAddress>;
};

const Body = ({ whatsapps }: Props) => {
  return (
    <SubsectionBodyContainer variant="large">
      {whatsapps?.map((whatsapp) => (
        <Whatsapp key={whatsapp.id} data={whatsapp} />
      ))}
    </SubsectionBodyContainer>
  );
};

export default Body;
